import EstimateWorkflows from '@/models/EstimateWorkflows';
import { parseIntProp } from '../_helpers';

export default {
    path: '/master',
    component: () => import('@/views/estimator/_EstimatorApp.vue'),
    meta: { requiresAuth: true, requiresUser: true, appName: 'estimator' },
    children: [
        {
            path: '',
            redirect: '/master/failed-folders',
        },
        {
            path: 'failed-folders',
            component: () => import('@/views/master/FailedFolder.vue'),
            meta: { title: 'Failed Folders' },
        },
    ],
};
